var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.236,
    height: 26.997,
    viewBox: "0 0 29.236 26.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-book",
    "data-name": "Icon ionic-ios-book",
    transform: "translate(-3.382 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_425",
    "data-name": "\\uD328\\uC2A4 425",
    d: "M10.266,4.507c3.8,0,7.031,1.962,7.031,5.766V11.4h0V31.359a.138.138,0,0,1-.267.049V31.4a6.612,6.612,0,0,0-5.787-4.957A8.925,8.925,0,0,0,4.7,29.053a.758.758,0,0,1-.464.2H3.916c-.26,0-.534-.19-.534-.429V8.452C3.375,6.195,6.462,4.507,10.266,4.507Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_426",
    "data-name": "\\uD328\\uC2A4 426",
    d: "M25.734,4.5c-3.8,0-7.031,1.962-7.031,5.766v1.125h0V31.352a.138.138,0,0,0,.267.049v-.007a6.68,6.68,0,0,1,5.787-4.957A8.909,8.909,0,0,1,31.3,29.046a.8.8,0,0,0,.464.2h.316c.26,0,.534-.19.534-.429V8.438C32.625,6.188,29.538,4.5,25.734,4.5Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.24694ca10aaecb125c4518edee5931a1.svg";
export { ForwardRef as ReactComponent };